import { logging } from '@/api/server';
import { LogEvent, LoggerHook, StringifyObjectsHook, createLogger } from 'vue-logger-plugin';

const ServerLogHook: LoggerHook = {
  // example using async/await:
  async run(event: LogEvent) {
    await logging(event.level, event.argumentArray);
  },
};

// create logger with options
export const logger = createLogger({
  enabled: true,
  consoleEnabled: true,
  level: 'debug',
  prefixFormat: ({ caller }) => (caller ? `[${caller?.fileName}:${caller?.functionName}:${caller?.lineNumber}]` : ``),
  beforeHooks: [StringifyObjectsHook],
  afterHooks: [ServerLogHook],
});
